module.exports = __webpack_public_path__ + "img/video-thumbnail2@2x.d0d48217.png";